import { Component, OnInit, OnDestroy } from '@angular/core';
import { InternalRoute, ExternalLink, HeaderUser } from '@uiowa/uiowa-header';
import { ApplicationUser, UserService, ImpersonationService } from './core';
import { Subscription, combineLatest } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit, OnDestroy {
    applicationName = 'Accounting Code Manual';
    externalLinks = [
        new ExternalLink('Accounting & Financial Reporting', 'https://afr.fo.uiowa.edu'),
        new ExternalLink('Grant Accounting', 'https://gao.fo.uiowa.edu'),
        new ExternalLink('Employee Self Service', 'https://hris.uiowa.edu/portal18')
    ];
    internalRoutes: InternalRoute[];
    user: HeaderUser;

    startTimer: boolean;
    private subscription: Subscription;

    constructor(
        private readonly userService: UserService,
        private readonly impersonationService: ImpersonationService) {
    }

    ngOnInit(): void {
        this.subscription = combineLatest([this.userService.user$]).subscribe(
            ([user]) => {
                this.user = <HeaderUser>{
                    userName: user.hawkId,
                    originalUserName: user.originalUser,
                };
                this.setupNavMenus(user);
                this.startTimer = user.isAuthenticated();
            });
    }

    setupNavMenus(user: ApplicationUser) {
        this.internalRoutes = [];
        this.internalRoutes.push(new InternalRoute('Introduction', 'introduction/introduction'),
            new InternalRoute('Resources', 'resources'));
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    stopImpersonate() {
        this.impersonationService.stopImpersonate();
    }
}
